import { render, staticRenderFns } from "./YZneed.vue?vue&type=template&id=5a39299b&scoped=true"
import script from "./YZneed.vue?vue&type=script&lang=js"
export * from "./YZneed.vue?vue&type=script&lang=js"
import style0 from "./YZneed.vue?vue&type=style&index=0&id=5a39299b&prod&lang=css"
import style1 from "./YZneed.vue?vue&type=style&index=1&id=5a39299b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39299b",
  null
  
)

export default component.exports